/* global cognitoUserPoolId */
/* global cognitoClientId */
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

const cognitoPoolData = {
  UserPoolId: cognitoUserPoolId,
  ClientId: cognitoClientId,
  Storage: new AmazonCognitoIdentity.CookieStorage({ domain: window.location.hostname }),
};

const userPool = new AmazonCognitoIdentity.CognitoUserPool(cognitoPoolData);
const user = userPool.getCurrentUser();


const logout = () => {
  if (user != null) {
    user.signOut(() => {
      console.log('User signed out.');
      document.cookie = 'PHPSESSID' + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      window.location.replace('/');
    });
  } else {
    console.log('Cannot get cognito user. User is not logged in.');
  }
};

window.addEventListener('DOMContentLoaded', () => {
  const logoutBtn = document.getElementById('logout-btn');
  const logoutBtnDropdown = document.getElementById('logout-btn-dropdown');
  if (!logoutBtn) {
    console.log('Cannot find logout button!');
    return;
  }
  if (!logoutBtnDropdown) {
    console.log('Cannot find logout button in dropdown menu!');
    return;
  }

  logoutBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    logout();
  });
  logoutBtnDropdown.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    logout();
  });
});
